import React from "react";

const Dashboard = React.lazy(() => import("./views/dashboard/Dashboard"));
const TicketIssuedViolation = React.lazy(() =>
  import("./views/dashboard/components/TicketIssuedViolation")
);

const BookletReceiving = React.lazy(() =>
  import("./views/booklet-receiving/BookletReceiving")
);
const BookletReceivingForm = React.lazy(() =>
  import("./views/booklet-receiving/BookletReceivingForm")
);
const BookletAllocation = React.lazy(() =>
  import("./views/booklet-allocation/BookletAllocation")
);
const TicketEncoding = React.lazy(() =>
  import("./views/ticket-encoding/TicketEncoding")
);
const TicketEncodingForm = React.lazy(() =>
  import("./views/ticket-encoding/TicketEncodingForm")
);
const Assessment = React.lazy(() => import("./views/assessment/Assessment"));

const AssessmentForm = React.lazy(() =>
  import("./views/assessment/AssessmentForm")
);

const Payment = React.lazy(() => import("./views/payment/Payment"));

const PaymentForm = React.lazy(() => import("./views/payment/PaymentForm"));
const SyncORDetails = React.lazy(() => import("./views/payment/SyncORDetails"));

// const CTOPayment = React.lazy(() =>
//   import("./views/payment/cto-payment/CTOPayment")
// );
const Collection = React.lazy(() => import("./views/collection/Collection"));
const TicketCollection = React.lazy(() =>
  import("./views/ticket-collection/TicketCollection")
);

const CollectionVsTicket = React.lazy(() =>
  import("./views/collection-vs-ticket/CollectionVsTicket")
);

// Maintenance -
const Enforcer = React.lazy(() =>
  import("./views/maintenance/enforcer/Enforcer")
);
const Supplier = React.lazy(() =>
  import("./views/maintenance/supplier/Supplier")
);

const Violation = React.lazy(() =>
  import("./views/maintenance/violation/Violation")
);

const ViolationForm = React.lazy(() =>
  import("./views/maintenance/violation/ViolationForm")
);

const Agency = React.lazy(() => import("./views/maintenance/agency/Agency"));
const Holiday = React.lazy(() => import("./views/maintenance/holiday/Holiday"));

const UserAccount = React.lazy(() =>
  import("./views/security/user-account/UserAccount")
);
const UserRoles = React.lazy(() =>
  import("./views/security/user-roles/UserRoles")
);
const UserAccess = React.lazy(() =>
  import("./views/security/user-access/UserAccess")
);
const SystemSettingForm = React.lazy(() =>
  import("./views/security/system-settings/SystemSettingForm")
);
const Reports = React.lazy(() => import("./views/reports/Reports"));

const SyncTicket = React.lazy(() => import("./views/sync-tickets/SyncTicket"));

const SyncTicketLogs = React.lazy(() =>
  import("./views/sync-tickets/components/SyncTicketLogs")
);
const SyncPaymentLogs = React.lazy(() =>
  import("./views/sync-tickets/components/SyncPaymentLogs")
);
// nash aug 10, 2023 - new page here - sync dashboard
const SyncDashboard = React.lazy(() =>
  import("./views/sync-tickets/components/SyncDashboard")
);

const InquiryForm = React.lazy(() => import("./views/Inquiry/InquiryForm"));
const LTOSettingsForm = React.lazy(() =>
  import("./views/sync-tickets/components/LTOSettingsForm")
);
const TrafficMapDetails = React.lazy(() =>
  import("./views/ticket-encoding/components/TrafficMapDetails")
);

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: "/", exact: true, name: "Home" },
  { path: "/dashboard", exact: true, name: "Dashboard", component: Dashboard },
  {
    path: "/dashboard/ticket-issued-violations",
    exact: true,
    name: "Ticket Issued Violations",
    component: TicketIssuedViolation,
  },
  {
    path: "/reports",
    name: "Reports",
    component: Reports,
    permission: "Permissions.Report.View",
  },
  {
    path: "/booklet-receiving",
    exact: true,
    name: "Booklet Receiving",
    component: BookletReceiving,
    permission: "Permissions.BookletReceiving.View",
  },
  {
    path: "/booklet-receiving/add",
    exact: true,
    name: "Booklet Receiving Form",
    component: BookletReceivingForm,
    permission: "Permissions.BookletReceiving.Create",
  },
  {
    path: "/booklet-allocation",
    exact: true,
    name: "Booklet Allocation",
    component: BookletAllocation,
    permission: "Permissions.BookletAllocation.View",
  },
  {
    path: "/ticket-encoding",
    exact: true,
    name: "Summary of Encoded Tickets",
    component: TicketEncoding,
    permission: "Permissions.TicketEncoding.View",
  },
  {
    path: "/ticket-encoding/add",
    exact: true,
    name: "Add Ticket Encoding",
    component: TicketEncodingForm,
    permission: "Permissions.TicketEncoding.Create",
  },
  {
    path: "/ticket-encoding/edit/:id",
    exact: true,
    name: "Edit Ticket Encoding",
    component: TicketEncodingForm,
    permission: "Permissions.TicketEncoding.Edit",
  },
  {
    path: "/ticket-encoding/traffic-heatmap",
    exact: true,
    name: "Traffic Apprehension Heatmap",
    component: TrafficMapDetails,
    permission: "Permissions.TicketEncoding.View",
  },
  {
    path: "/assessment",
    exact: true,
    name: "Summary of Assessment",
    component: Assessment,
    permission: "Permissions.TicketAssessment.View",
  },
  {
    path: "/assessment/add",
    exact: true,
    name: "Assessment Form",
    component: AssessmentForm,
    permission: "Permissions.TicketAssessment.Create",
  },
  {
    path: "/assessment/edit/:id",
    exact: true,
    name: "Assessment Form",
    component: AssessmentForm,
    permission: "Permissions.TicketAssessment.Edit",
  },
  {
    path: "/payment",
    exact: true,
    name: "Summary of Paid Tickets",
    component: Payment,
    permission: "Permissions.TicketPayment.View",
  },
  {
    path: "/payment/add",
    exact: true,
    name: "Payment Encoding Form",
    component: PaymentForm,
    permission: "Permissions.TicketPayment.Create",
  },
  {
    path: "/payment/edit/:id",
    exact: true,
    name: "Payment Encoding Form",
    component: PaymentForm,
    permission: "Permissions.TicketPayment.Edit",
  },
  {
    path: "/payment/sync",
    exact: true,
    name: "Sync OR Details",
    component: SyncORDetails,
    permission: "Permissions.TicketPayment.View",
  },
  {
    path: "/collection",
    exact: true,
    name: "Collection Summary",
    component: Collection,
  },
  {
    path: "/inquiry",
    exact: true,
    name: "LTO Inquiry Form",
    component: InquiryForm,
  },
  {
    path: "/sync-tickets",
    exact: true,
    name: "Sync Tickets",
    component: SyncTicket,
  },
  {
    path: "/sync-ticket-logs",
    exact: true,
    name: "Sync Ticket Logs",
    component: SyncTicketLogs,
  },
  {
    path: "/sync-payment-logs",
    exact: true,
    name: "Sync Payment Logs",
    component: SyncPaymentLogs,
  },
  // nash aug 10, 2023 - new page here - sync dashboard
  {
    path: "/lto-sync-dashboard",
    exact: true,
    name: "Sync Dashboard",
    component: SyncDashboard,
  },
  {
    path: "/lto-sync-settings",
    exact: true,
    name: "LTO Sync Settings",
    component: LTOSettingsForm,
  },
  // {
  //   path: "/collection",
  //   exact: true,
  //   name: "Collection Summary",
  //   component: TicketCollection,
  // },
  // {
  //   path: "/collection/collection-vs-ticket",
  //   exact: true,
  //   name: "Collection vs Ticket Summary",
  //   component: CollectionVsTicket,
  // },

  //Maintenance
  {
    path: "/maintenance/enforcer",
    exact: true,
    name: "List of Enforcers",
    component: Enforcer,
  },
  {
    path: "/maintenance/supplier",
    exact: true,
    name: "List of Suppliers",
    component: Supplier,
  },
  {
    path: "/maintenance/violation",
    exact: true,
    name: "List of Violations",
    component: Violation,
  },
  {
    path: "/maintenance/violation/add",
    exact: true,
    name: "Violation Form",
    component: ViolationForm,
  },
  {
    path: "/maintenance/violation/edit/:id",
    exact: true,
    name: "Violation Form",
    component: ViolationForm,
  },
  {
    path: "/maintenance/agency",
    exact: true,
    name: "List of Agencies",
    component: Agency,
  },
  {
    path: "/maintenance/holiday",
    exact: true,
    name: "List of Holidays",
    component: Holiday,
  },
  {
    path: "/security/user-account",
    exact: true,
    name: "User Account",
    component: UserAccount,
  },
  {
    path: "/security/user-roles",
    exact: true,
    name: "User Roles",
    component: UserRoles,
  },
  {
    path: "/security/user-access",
    exact: true,
    name: "User Access",
    component: UserAccess,
  },
  {
    path: "/security/system-settings",
    exact: true,
    name: "System Settings",
    component: SystemSettingForm,
  },
];

export default routes;
